import { FunctionComponent } from "react";
import { Course } from "../../courses/courses.types";
import { useTranslation } from "react-i18next";
import { COURSE_ARCHIVE_OVERLAP_PERIOD } from "../../common/constants";
import { format } from "date-fns/format";
import { differenceInDays } from "date-fns/differenceInDays";

export const WarningBannerPageHeader:FunctionComponent<{course:Course }>  = ({course }) => {
  const { t } = useTranslation();
  let message = "";
  const showWarningBanner =
          !!course.toBeArchivedOn &&
          differenceInDays(course.toBeArchivedOn, new Date()) <= COURSE_ARCHIVE_OVERLAP_PERIOD;
  if(showWarningBanner)
  message=t("deepLinking.courseWillBeArchivedSoonCourseDetailsMessage", {
                            toBeArchivedOn: format(course.toBeArchivedOn!, "dd.MM.yyyy")
                        })
  return (
    <>
      {showWarningBanner && (
        <div className="rounded-md bg-yellow-400 px-4 py-3 my-3 text-sm text-black shadow-sm">
          {message}
        </div>
      )}
    </>
  );
}
